let apiHost;

if (process.env.NODE_ENV === 'production') {
  apiHost = "";
} else if (process.env.NODE_ENV === 'development') {
  apiHost = 'http://0.0.0.0:40079';
}

if (process.env.REACT_APP_API_HOST) {
  apiHost = process.env.REACT_APP_API_HOST;
}

export const HOST = apiHost;
export const APISRC = HOST + '/api';



// WEBPACK FOOTER //
// ./src/constants/Fetch.js